import { useState, useEffect } from "react";
import { getToday } from "../utils";

export default function useToday() {
  const [today, setToday] = useState(getToday);

  useEffect(() => {
    const check = () => {
      const now = getToday();
      if (now !== today) setToday(now);
    };
    const id = setInterval(check, 60000);
    return () => clearInterval(id);
  }, [today]);

  return today;
}
